import { paths } from '@app/paths';
import { useTranslation } from 'react-i18next';

import { Layout, Menu, Translate } from '../various/Icons';
import { SectionFormHeading } from '../various/SectionHeading';
import { SidebarLayout } from '../various/SidebarLayout';
import { NavigationItem } from '../various/SidebarNavigation';

interface Props {
  activePath: string;
  isLoading: boolean;
  hasChanges?: boolean;
  isDisabled?: boolean;
  onCancel?: () => void;
  formName: string;
}

export const SettingsLayout = ({
  children,
  activePath,
  hasChanges = false,
  isDisabled,
  isLoading,
  onCancel,
  formName,
}: React.WithChildren<Props>) => {
  const { t } = useTranslation(['common', 'settings']);
  const settingsNavigation: NavigationItem[] = [
    {
      icon: Layout,
      link: paths.SETTINGS_CUSTOMIZATION,
      subtitle: t('settings:navigation.customization.subtitle'),
      title: t('settings:navigation.customization.title'),
    },
    {
      icon: Menu,
      link: paths.SETTINGS_NAVIGATION,
      subtitle: t('settings:navigation.navigation.subtitle'),
      title: t('settings:navigation.navigation.title'),
    },
    {
      icon: Translate,
      link: paths.SETTINGS_TRANSLATIONS,
      subtitle: t('settings:navigation.translations.subtitle'),
      title: t('settings:navigation.translations.title'),
    },
  ];

  return (
    <div className="px-4 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <SectionFormHeading
          heading={t('common:settings')}
          isLoading={isLoading}
          hasChanges={hasChanges}
          isDisabled={isDisabled}
          onReset={onCancel}
          formName={formName}
        />
        <SidebarLayout storageKey="generalSettings" navigationItems={settingsNavigation} activePath={activePath}>
          {children}
        </SidebarLayout>
      </div>
    </div>
  );
};
